import Rest from './rest';

const RESOURCE = "ride";

export default {

    filterRides: function (params) {
        return Rest.get(RESOURCE, {params})
    },
    downloadExcel: function (params) {
        return Rest.downloadExcel(RESOURCE + "/excel", null, {params})
    },
    notify: function (id) {
        return Rest.put(`${RESOURCE}/${id}/notify`);
    },
};



// WEBPACK FOOTER //
// ./src/services/RideService.js